/**
 * @typedef {(DIE | IDLE)} TypeAnimation An animation.
 */

/**
 * The 'DIE' animation.
 * @type {'die'}
 * @constant
 */
const DIE = 'die';

/**
 * The 'IDLE' animation.
 * @type {'idle'}
 * @constant
 */
const IDLE = 'idle';

export {

    DIE,
    IDLE
};
